import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import 'leaflet';
import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

declare const L: any;

@Injectable()
export class MapService {
  readonly defaultLat = 52.1;
  readonly defaultLng = 5;
  readonly defaultZoom = 8;
  readonly geoserverWmsUrl = `${environment.geoserverUrl}/wms`;
  readonly geoserverWfsUrl = `${environment.geoserverUrl}/wfs`;
  readonly osmTilesUrl = `${environment.tileServerRoot}/styles/default/{z}/{x}/{y}.png`;
  readonly hectometreTilesUrl = `${environment.tileServerRoot}/styles/hectometre-signs/{z}/{x}/{y}.png`;
  readonly fcdSegmentsTilesUrl = `${environment.tileServerRoot}/styles/fcd-segments/{z}/{x}/{y}.png?token=${environment.fcdSegmentsIngressApiKey}`;

  constructor(private readonly http: Http) {}

  getFeatureInfo(mapHeight, mapWidth, minY, minX, maxY, maxX, coordinaatX, coordinaatY, layers, contractid?) {
    const layersNames = layers.join(',');

    let url =
      `${this.geoserverWmsUrl}?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&QUERY_LAYERS=${layersNames}&LAYERS=${layersNames}` +
      `&INFO_FORMAT=application/json&FEATURE_COUNT=50&X=${coordinaatX}&Y=${coordinaatY}&SRS=EPSG:4326&WIDTH=${mapWidth}` +
      `&HEIGHT=${mapHeight}&BBOX=${minY},${minX},${maxY},${maxX}`;

    if (contractid) {
      url = `${url}&VIEWPARAMS=contractid:${contractid}`;
    }

    return this.http
      .get(url)
      .map(res => res.json())
      .map(features => features.features);
  }

  getWMSLayer(layerName: string, params?: string): L.TileLayer {
    const options: any = {
      version: '1.1.1',
      layers: layerName,
      format: 'image/png',
      transparent: true,
      srs: 'EPSG:4326'
    };

    if (params) {
      options.viewparams = params;
    }

    return L.tileLayer.wms(this.geoserverWmsUrl, options);
  }

  getGeoJsonInBounds(
    typeName: string,
    bounds: L.LatLngBounds,
    params?: any
  ): Observable<GeoJSON.FeatureCollection<any>> {
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();

    let url =
      `${this.geoserverWfsUrl}?service=WFS&request=GetFeature&version=2.0.0&typeName=${typeName}&outputFormat=application/json` +
      `&bbox=${sw.lat},${sw.lng},${ne.lat},${ne.lng}`;
    if (params) {
      url += `&${this.paramsToViewParams(params)}`;
    }

    return this.http.get(url).map(res => res.json());
  }

  getGeoJson(typeName: string, params?: any): Observable<GeoJSON.FeatureCollection<any>> {
    let url = `${this.geoserverWfsUrl}?service=WFS&request=GetFeature&version=2.0.0&typeName=${typeName}&outputFormat=application/json`;
    if (params) {
      url += `&${this.paramsToViewParams(params)}`;
    }

    return this.http.get(url).map(res => res.json());
  }

  /**
   * Returns "viewparams=p1:v1;p2:v2;..."
   */
  private paramsToViewParams(params: any): string {
    const keys: string[] = Object.keys(params);
    if (keys.length === 0) {
      return '';
    }

    let viewParams = 'viewparams=';
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = params[key];

      viewParams += `${key}:${value}`;
      if (i !== keys.length - 1) {
        viewParams += '%3B';
      }
    }

    return viewParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/map.service.ts